export function gateDecisionDraftKey(gateId: string): string {
    return `os:form:gate-decision:${gateId}`
}

/** The per-question replies drafted on a CEO question gate, kept beside its note. */
export function gateAnswersDraftKey(gateId: string): string {
    return `${gateDecisionDraftKey(gateId)}:answers`
}

/** Only discard a draft after the server has accepted the decision. */
export function clearGateDecisionDraft(gateId: string): void {
    try {
        for (const key of [gateDecisionDraftKey(gateId), gateAnswersDraftKey(gateId)]) {
            localStorage.removeItem(key)
            // Keep any mounted copy of the same gate in sync as well as other browser tabs.
            window.dispatchEvent(new StorageEvent('storage', { key, newValue: null, storageArea: localStorage }))
        }
    } catch {
        // Storage being blocked must not turn a successful decision into an error.
    }
}
